import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpoints } from '../helpers/constants';
import { debounce } from '../helpers';

gsap.registerPlugin(ScrollTrigger);
class VisualStoryRow extends Component {
  setupDefaults() {
    this.dom = {
      line: this.el.querySelector('.visual-story-row__line'),
      triggerCont: this.el.querySelector(
        '.visual-story-row__trigger-container'
      ),
      innerContainer: this.el.querySelector('.visual-story-row__inner'),
      img: this.el.querySelector('img'),
      picture: this.el.querySelector('.visual-story-row-img-container'),
      imgCont: this.el.querySelector('.visual-story-row__image'),
      copy: this.el.querySelector('.visual-story-content-row__copy'),
      title: this.el.querySelector('.visual-story-row__title')
    };

    this.breakpoint = window.matchMedia(`(min-width: ${breakpoints.tablet}px)`);

    this.initImageScroll();
    this.initLineScroll();
    this.watchMainElement();
  }

  addListeners() {
    const { triggerCont, line } = this.dom;
    window.addEventListener(
      'resize',
      debounce(() => {
        ScrollTrigger.refresh();
        ScrollTrigger.update();

        triggerCont.style = null;
        line.style = null;

        this.initLineScroll(this);
      }, 200)
    );

    window.addEventListener('scroll', this.animateLine.bind(this));
  }

  watchMainElement() {
    const resizeObserver = new ResizeObserver(entries => {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    });

    resizeObserver.observe(document.querySelector('main'));
  }

  initImageScroll() {
    ScrollTrigger.matchMedia({
      [`(max-width: ${breakpoints.tablet - 1}px)`]: () => {
        this.animateImage();
      }
    });
  }

  initLineScroll() {
    const { innerHeight } = window;
    const { offsetTop: containerTop, offsetHeight: containerHeight } = this.el;
    const { offsetHeight: triggerContainerHeight } = this.dom.triggerCont;
    const { offsetHeight: titleHeight } = this.dom.title;

    if (this.breakpoint.matches) {
      this.lineStart = containerTop - innerHeight * 0.5;
      this.lineEnd = containerHeight + this.lineStart;
    } else {
      this.lineStart = containerTop - innerHeight * 0.7;
      this.lineEnd = this.lineStart + triggerContainerHeight - titleHeight - 55;
    }

    this.animateLine();
  }

  animateImage() {
    const { triggerCont, img, imgCont, innerContainer } = this.dom;

    triggerCont.style.height = `${innerContainer.offsetHeight * 2}px`;

    gsap.to(img, {
      scrollTrigger: {
        trigger: triggerCont,
        start: 'top top',
        end: 'bottom top',
        endTrigger: imgCont,
        pin: imgCont,
        pinSpacing: false,
        scrub: true
      },
      scale: 1.5,
      transformOrigin: 'center',
      scrub: 3
    });
  }

  animateLine() {
    const { pageYOffset } = window;

    if (pageYOffset >= this.lineStart && pageYOffset <= this.lineEnd) {
      this.dom.line.style.transform = `translateY(${
        pageYOffset - this.lineStart
      }px)`;
    } else if (pageYOffset > this.lineEnd) {
      this.dom.line.style.transform = `translateY(${
        this.lineEnd - this.lineStart
      }px)`;
    }
  }
}

export default VisualStoryRow;
